import {makeObservable, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";

export class AppFollowingDisplayModel extends BaseWidgetDisplayModel {
  @observable onEditMode: Boolean;
  @observable viewType: String;
  @observable isVisible: Boolean;

  constructor() {
    super();

    this.onEditMode = false;
    this.isVisible = false;

    makeObservable(this);
  }
}
